import type { FC, HTMLAttributes, ReactNode } from 'react';

import styles from './FullWidth.module.css';

export const FullWidth: FC<
  { children: ReactNode; className?: string } & HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...props }) => (
  <div className={`${styles.wrapper} ${className || ''}`} {...props}>
    {children}
  </div>
);
